<template>
    <v-card variant="outlined" hover @click="$emit('selected', destination)">
        <v-img
            :src="$filters.srcHost(destination.img)"
            :lazy-src="$filters.srcHost('/placeholder.png')"
            :height="250"
            cover
            eager
        />
        <v-card-text class="d-flex align-center">
            <span class="fi me-2" :class="`fi-${destination.countryCode}`" />
            <span class="text-h5">
                {{ destination.name }}
            </span>
        </v-card-text>
    </v-card>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class PopularDestination extends Vue {
        @Prop({required: true}) destination
    }

    export default PopularDestination
</script>
